import { createFileRoute, redirect } from '@tanstack/react-router';
import { AGGREGATE_NAMES, USER_ROLES } from 'cpool-constants';
import { schemaCorporationResolver_List } from 'cpool-tables/backend-resolvers';

import { authoriseUser } from '~/features/auth/utils/authoriseUser';
import { getQueryOptions } from '~/queryUtils/getQueryOptions';
import { useUserStore } from '~/store/userStore';

const corporationsQueryOptions = () =>
    getQueryOptions({
        aggregateName: AGGREGATE_NAMES.CORPORATION,
        resolverName: 'list',
        schema: schemaCorporationResolver_List,
    });

export const Route = createFileRoute('/_app/management/corporations/')({
    beforeLoad: ({ location }) => {
        authoriseUser([USER_ROLES.admin], location);
        const content = 'ROUTE_TITLE.CORPORATION_MANAGEMENT';
        return {
            meta: [
                {
                    content,
                    name: 'description',
                },
                {
                    content,
                    name: 'title',
                },
            ],
        };
    },
    loader: async ({ context, location }) => {
        const { user } = useUserStore.getState();
        if (!user) {
            throw redirect({ search: { redirect: location.href }, to: '/login' });
        }
        await context.queryClient.ensureQueryData(corporationsQueryOptions());
    },
});
